import { AI_SUMMARY_NOTE } from '../constants/copy';

const MONTHS_IN_YEAR = 12;

const pluralize = (value: number, unit: string) => (value === 1 ? unit : `${value} ${unit}s`);

/**
 * The attribution line under the AI summary, e.g. "AI summary of reviews over
 * the past 2 years". Whole numbers of years read better than the equivalent
 * month count, so 24 becomes "2 years" rather than "24 months".
 *
 * When the upstream reports no lookback period the note is rendered without
 * one: an unqualified note is better than inventing a window.
 */
export const getAiSummaryNote = (lookbackMonths: number | null): string => {
  if (!lookbackMonths || lookbackMonths <= 0) {
    return AI_SUMMARY_NOTE;
  }

  const period =
    lookbackMonths % MONTHS_IN_YEAR === 0
      ? pluralize(lookbackMonths / MONTHS_IN_YEAR, 'year')
      : pluralize(lookbackMonths, 'month');

  return `${AI_SUMMARY_NOTE} over the past ${period}`;
};
